<template>
    <div class="welcome">
        <div class="quickly quickly-inner">
            <div class="btnList">
                <Permission allowed="business.factor.list">
                    <div class='items' @click="$router.push({path: '/business/agent/list'})">
                        <div>
                            <img src="../../../assets/img/agent.png" />
                        </div>
                        <span class="name">代理商列表</span>
                    </div>
                </Permission>
                <Permission allowed="business.sites.list">
                    <div class='items' @click="$router.push({path: '/business/site/list'})">
                        <div>
                            <img src="../../../assets/img/site_1.png" />
                        </div>
                        <span class="name">站点列表</span>
                    </div>
                </Permission>
                <Permission allowed="business.cities.list">
                    <div class='items' @click="$router.push({path: '/business/cities/list'})">
                        <div>
                            <img src="../../../assets/img/city.png" />
                        </div>
                        <span class="name">城市列表</span>
                    </div>
                </Permission>
                <Permission allowed="business.balance.list">
                    <div class='items' @click="$router.push({path: '/business/balance/list'})">
                        <div>
                            <img src="../../../assets/img/lan.png" />
                        </div>
                        <span class="name">代理商总览</span>
                    </div>
                </Permission>
                <Permission allowed="business.hotline.list">
                    <div class='items' @click="$router.push({path: '/business/hotline/list'})">
                        <div>
                            <img src="../../../assets/img/phone_1.png" />
                        </div>
                        <span class="name">400大号</span>
                    </div>
                </Permission>
                <Permission allowed="business.telephone.list">
                    <div class='items' @click="$router.push({path: '/telephone/list'})">
                        <div>
                            <img src="../../../assets/img/phone_level.png" />
                        </div>
                        <span class="name">400分机号</span>
                    </div>
                </Permission>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BussinessWelcome'
}
</script>
<style scoped lang="less">
@import url('../../../assets/style/welcome.less');
</style>